



















import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';

// @ts-ignore
import { RecycleScroller } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

import MyList from '@/mixins/list';
import item_add from '@/views/agreement/item_add.vue';

@Component({
  components: {
    RecycleScroller,
  },
})
export default class extends Mixins(MyList) {
    @Prop() datas!: any[]

    @Prop() handleInfiniteOnLoad!: Function
}
